import {defaultButtonStyles} from '../../elements/Button';
import getLocale from '../../../hooks/getLocale';
import {SanityLinkExternal} from '../../../types';
import clsx from 'clsx';

/**
 * Wrapper around Hydrogen's `<BuyNowButton />` which will
 * display a disabled 'sold out' button if variant is not available for sale
 */

type Props = {
  link: SanityLinkExternal;
};

export default function ExternalVendorLinkButton({link}: Props) {
  const styling = 'w-full whitespace-nowrap border-[3px] border-black ';
  const title =
    typeof link.title === 'object' ? getLocale(link.title) : link.title;
  return link.url ? (
    <a
      className={clsx(
        styling,
        'md:hover:border-gray',
        defaultButtonStyles({mode: 'secondary'}),
      )}
      rel="noreferrer"
      href={link.url}
      target={link.newWindow ? '_blank' : '_self'}
    >
      {title}
    </a>
  ) : (
    <div
      className={clsx(
        styling,
        'cursor-default rounded-lg bg-black px-[18px] py-[6px] text-center text-white',
      )}
    >
      {title}
    </div>
  );
}
